import { BasicFilter, FilterType } from "./../../filters.d";

export const ACTIVITY_LOGS_FILTERS: BasicFilter[] = [
  {
    id: "createdAt",
    label: "Data",
    type: FilterType.Date,
  },
  {
    id: "userId",
    label: "Użytkownik",
    type: FilterType.User,
  },
  {
    id: "activity",
    label: "Rodzaj aktywności",
    type: FilterType.Activity,
  },
  {
    id: "subjectType",
    label: "Obiekt",
    type: FilterType.ActivityLogsSubjectType,
  },
  {
    id: "project",
    label: "Projekt",
    type: FilterType.Project,
  },
];
